import React, { useEffect, useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Label,
  Input,
  Button,
} from "reactstrap";
import { useNavigate, useParams } from "react-router-dom";

import apiClient from "../../axiosInstance";
import showAlert from "../../components/Common/ShowAlert";
import Breadcrumbs from "../../components/Common/Breadcrumb";

const UpdateExpenseType = () => {
  const [breadcrumbItems] = useState([
    { title: "Daryeel", link: "/" },
    { title: "Update Expense Type", link: "#" },
  ]);

  const navigate = useNavigate();
  const { id } = useParams();

  const [formData, setFormData] = useState({
    name: "",
    description: "",
  });

  useEffect(() => {
    const fetchOne = async () => {
      try {
        const res = await apiClient.get(`/expense/types/${id}`);
        const et = res.data.response;
        setFormData({
          name: et?.name || "",
          description: et?.description || "",
        });
      } catch (err) {
        console.error("Error fetching expense type:", err);
      }
    };
    fetchOne();
  }, [id]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await apiClient.put(`/expense/types/${id}`, formData);
      await showAlert({
        title: "Expense Type",
        text: res.data.message,
        icon: res.data.status,
        goBack: res.data.status === "success",
        navigate,
        timer: 3000,
      });
    } catch (err) {
      console.error("Error updating expense type:", err);
    }
  };

  return (
    <div className="page-content">
      <Container fluid>
        <Breadcrumbs
          title="Update Expense Type"
          breadcrumbItems={breadcrumbItems}
        />
        <form onSubmit={handleSubmit}>
          <Row>
            <Col lg="12">
              <Card>
                <CardBody>
                  <h4 className="card-title d-flex justify-content-between align-items-center">
                    Update Expense Type
                    <i
                      className="ri-arrow-left-line"
                      style={{ fontSize: "1.25rem", cursor: "pointer" }}
                      onClick={() => navigate(-1)}
                    ></i>
                  </h4>

                  <hr className="bg-primary" />

                  <Row>
                    <Col lg="6" className="mt-3">
                      <Label className="form-label">Name</Label>
                      <Input
                        type="text"
                        name="name"
                        placeholder="Enter expense type name"
                        value={formData.name}
                        onChange={handleInputChange}
                        required
                      />
                    </Col>
                    <Col lg="6" className="mt-3">
                      <Label className="form-label">Description</Label>
                      <Input
                        type="text"
                        name="description"
                        placeholder="Enter description"
                        value={formData.description}
                        onChange={handleInputChange}
                      />
                    </Col>
                  </Row>

                  <div className="row d-flex justify-content-end">
                    <div className="col-md-2 col-6">
                      <Button
                        type="submit"
                        color="success"
                        className="mt-4 w-100"
                      >
                        Submit
                      </Button>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </form>
      </Container>
    </div>
  );
};

export default UpdateExpenseType;
